import { useMutation } from "react-query";
import { ParametrosUnidades } from "./typings/unidade";
import http from "infra/http";

function useSaveParametrosUnidades(id: string) {
  return useMutation(
    (data: ParametrosUnidades) => {
      return http.put(`/v1/unidades/${id}/parametros`, data);
    },
    { retry: false }
  );
}

export default useSaveParametrosUnidades;
